// Секция «Моей коллекции», к которой страница прокручивается сразу при
// открытии (переход «к секции», например из новости о рейтинговых обличиях
// в главном меню — см. RankSkinsNewsModal)
export const INVENTORY_FOCUS_SECTIONS = {
  RANK_SKINS: 'rank_skins',
};
